<template>
  <div id="menber_center">
    <div class="h_title padding-30" :style="{'background-color': $store.state.color}">
      <img src="static/images/menber.jpg" class="m-b-15" />
      <div class="menber_name">
        <div class="m_name">{{info.data.username}}</div>
        <span>{{info.data.memberRank.name}}</span>
      </div>
    </div>
    <div class="b_cont">
      <div class="pay_data">
        <ul class="padding-20">
          <li>
            <a href="javascript:;" @click="page(1)">
            <div class="data_name">待支付</div></a>
          </li>
          <li>
            <a href="javascript:;" @click="page(2)">
            <div class="data_name">待发货</div></a>
          </li>
          <li>
            <a href="javascript:;">￥{{info.data.deposit || 0}}RMB</a>
            <div class="data_name">账户余额</div>
          </li>
        </ul>
      </div>
      <div class="pay_data_menu">
        <ul>
          <li class="data_menu_1"><a href="#/order" class="padding-15 raduis-3"><i class="xybicon"></i><span>查看所有订单</span><em class="xybicon"></em></a></li>
          <li class="data_menu_2"><a href="#/address" class="padding-15 raduis-3"><i class="xybicon"></i><span>我的收货地址</span><em class="xybicon"></em></a></li>
          <li class="data_menu_4"><a href="#/info" class="padding-15 raduis-3"><i class="xybicon"></i><span>修改个人信息</span><em class="xybicon"></em></a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['info', 'enterpriseId'])
  },
  created () {
    this.get()
  },
  methods: {
    get () {
      var ctx = this
      window.$.ajax({
        url: '/rest/api/shop/member/info',
        data: {
          enterpriseId: this.enterpriseId
        },
        success (res) {
          if (res.success) {
            ctx.$store.commit('setInfo', res.attributes)
          } else {
            // window.alert(res.msg)
          }
        }
      })
    },
    page (e) {
      this.$router.push({name: 'order', params: {active: e}})
    }
  }
}
</script>
<style>
/*会员中心*/
#menber_center .h_title {
  background:#62a8ea;
  /*display*/
  display:-webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  /*flex-direction*/
  -webkit-box-orient:vertical;/*horizontal*/
  -webkit-box-direction:normal;/*reverse*/
  -moz-box-orient:vertical;
  -moz-box-direction:normal;
  flex-direction:column;/*row*/
  -webkit-flex-direction:column;
  /*flex-wrap*/
  -webkit-flex-wrap:wrap;/*nowrap*/
  -webkit-box-lines:multiple;/*single*/
  -moz-flex-wrap:wrap;
  flex-wrap:wrap;
  /*justify-content*/
  -webkit-justify-content:center;
  justify-content:center;/*主轴上对齐（横轴）*/
  -moz-box-pack:center;
  -webkit--moz-box-pack:center;
  box-pack:center;
  /*align-items*/
  align-items:center;/*交叉轴对齐（垂直）*/
  -webkit-align-items:center;
  box-align:center;
  -moz-box-align:center;
  -webkit-box-align:center;
}
#menber_center .h_title>img {
  width:100px;
  height:100px;
  -moz-border-radius: 50px;
    -khtml-border-radius: 50px;
    -webkit-border-radius: 50px;
    border-radius: 50px;
    -moz-border-radius-bottomleft: 50px;
    -moz-border-radius-bottomright: 50px;
    -khtml-border-radius: 50px;
    -webkit-border-bottom-left-radius: 50px;
    -webkit-border-bottom-right-radius: 50px;
    border-bottom-left-radius: 50px;
    border-bottom-right-radius: 50px;
    border:3px solid #fff;
}
#menber_center .h_title>.menber_name {
  color:#fff;
  font-size:16px;
  line-height:1.5;
  text-align:center;
}
#menber_center .h_title>.menber_name .m_name {
  font-size:20px;
}
#menber_center .h_title>.menber_name span {
  opacity: 0.5;
  -moz-opacity: 0.5;
  filter:alpha(opacity=50);
}
#menber_center .pay_data ul {
  /*display*/
  display:-webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  /*flex-direction*/
  -webkit-box-orient:horizontal;/*horizontal*/
  -webkit-box-direction:normal;/*reverse*/
  -moz-box-orient:horizontal;
  -moz-box-direction:row;
  flex-direction:row;/*row*/
  -webkit-flex-direction:row;
  /*flex-wrap*/
  -webkit-flex-wrap:wrap;/*nowrap*/
  -webkit-box-lines:multiple;/*single*/
  -moz-flex-wrap:wrap;
  flex-wrap:wrap;
  /*justify-content*/
  -webkit-justify-content:center;
  justify-content:center;/*主轴上对齐（横轴）*/
  -moz-box-pack:center;
  -webkit--moz-box-pack:center;
  box-pack:center;
  /*align-items*/
  align-items:center;/*交叉轴对齐（垂直）*/
  -webkit-align-items:center;
  box-align:center;
  -moz-box-align:center;
  -webkit-box-align:center;
}
#menber_center .pay_data li {
  text-align:center;
  margin:0 10%;
  _margin:0 5%;
  color:#2a333c;
  font-size:14px;
}
#menber_center .pay_data a {
  color:#5f9ea0;
  font-size:20px;
}
#menber_center .pay_data a:hover {
  color:#4E97D9;
}
#menber_center .pay_data_menu li {
  width:100%;
  clear:both;
  margin-bottom:-1px;
}
#menber_center .pay_data_menu li a {
  display:block;
  color:#76838f;
  font-size:14px;
  line-height:1.5;
  border:1px solid #eee;
  transition:all 0.3s ease 0s;
  -moz-transition:all 0.3s ease 0s;
  -webkit-transition:all 0.3s ease 0s;
  -o-transition:all 0.3s ease 0s;
}
#menber_center .pay_data_menu li a:hover {
  background:#f3f7f9;
}
#menber_center .pay_data_menu li a em {
  float:right;
}
#menber_center .pay_data_menu li a em:before {
  content:"\e627";
}
#menber_center .pay_data_menu li a i {
  padding:0 10px 0 0;
}
#menber_center .pay_data_menu li.data_menu_1 a i:before {
  content:"\e6ea";
}
#menber_center .pay_data_menu li.data_menu_2 a i:before {
  content:"\e632";
}
#menber_center .pay_data_menu li.data_menu_3 a i:before {
  content:"\e6ed";
}
#menber_center .pay_data_menu li.data_menu_4 a i:before {
  content:"\e6c7";
}
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue